import { RequireUser } from '../../../util/decorators';
import { devices } from './devices/store';
import { flow } from './flow/store';
import { zones } from './zones/store';

export const homey = {
	namespaced: true,

	state: {
		api: null,
		connecting: false,
		selectedId: null,
		selectedName: null,
	},

	getters: {
		selected(state, getters){
			return state.api;
		},
		selectedId(state){
			return state.selectedId;
		},
		selectedName(state){
			return state.selectedName;
		},
		isOnline(state){
			// const selected = getters.selected;
			// return selected && selected.isOnline;
			return Boolean(state.api);
		},
		isConnecting(state){
			return state.connecting;
		},
		all(state, getters, rootState){
			if (!rootState.api.user) return null;
			return rootState.api.user.homeys || [];
		},
		api(state){
			return state.api;
		}
	},

	mutations: {
		setHomey(state, { api }){
			const oldApi = state.api;
			state.api = api;
			state.connecting = false;

			api.enableRouteDetection();

			if (oldApi) oldApi.destroy();
		},
		setSelected(state, { id, name }){
			state.selectedId = id;
			state.selectedName = name;
		},
		setConnecting(state, isConnecting){
			state.connecting = isConnecting;
		},
		_clearAll(state){
			state.api = null;
			state.connecting = false;
			state.selectedId = null;
			state.selectedName = null;
		}
	},

	actions: {
		@RequireUser()
		retrieveAll(){
			return Promise.resolve();
		},
		@RequireUser()
		async selectHomey({ commit, getters, dispatch, state }, { id, name }){
			const homey = (getters.all || []).find(h => h.id === id);
			if (state.connecting) return Promise.reject('already_connecting');
			if (!homey) return Promise.reject(new Error(`Homey with id ${id} not found`));
			if (homey.state !== 'online') return Promise.reject(new Error(`${homey.name} could not be selected since it is offline!`));
			if (getters.selectedId === id && getters.selected) return Promise.resolve();
			dispatch('clearAll');
			commit('setSelected', { id, name });
			commit('setConnecting', true);

			dispatch('api/getCachedUser', null, {root: true})
				.then((user) => {
					return user.getHomeyById(id);
				})
				.then((homey) => {
					return homey.authenticate();
				})
				.then((api) => {
					commit('setHomey', { api });
				})
				.catch((err) => {
					commit('setConnecting', false);
					return Promise.reject(err);
				});
		},
		unselectHomey({ dispatch }){
			return dispatch('clearAll');
		},
		clearAll({ dispatch, commit }){
			commit('_clearAll');
			Object.keys(homey.modules).forEach(module => dispatch(`${module}/clearAll`));
		}
	},

	modules: {
		flow,
		zones,
		devices
	},

	plugins: [
		(store) => {
			if (store.getters['api/authenticated'] && !store.getters['api/homey/api'] && store.getters['api/homey/selectedId']) {
				store.dispatch('api/homey/selectHomey', {
					id: store.getters['api/homey/selectedId'],
					name: store.getters['api/homey/selectedName']
				});
			}
		},
	],
};
